import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import branding from "../assets/branding.jpg";

export default function BrandStory() {
  const navigate = useNavigate();

  return (
    <section className="overflow-hidden bg-[#173C39] py-16 text-white sm:py-20 lg:py-24">
      <div className="mx-auto grid max-w-7xl items-center gap-10 px-4 sm:px-6 lg:grid-cols-[0.95fr_1.05fr] lg:gap-16 lg:px-8">
        <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, amount: 0.2 }} transition={{ duration: 0.7 }} className="relative">
          <div className="overflow-hidden rounded-[2rem] shadow-2xl ring-1 ring-white/10">
            <img src={branding} alt="Handmade Afghan rugs" className="h-[420px] w-full object-cover sm:h-[540px]" />
          </div>
          <div className="absolute -bottom-5 right-4 rounded-2xl bg-[#F8F3E7] px-5 py-4 text-[#173C39] shadow-xl sm:right-8 sm:px-7">
            <p className="text-2xl font-bold sm:text-3xl">100+</p>
            <p className="text-xs font-semibold uppercase tracking-wider opacity-70">Unique designs</p>
          </div>
        </motion.div>

        <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, amount: 0.2 }} transition={{ duration: 0.7 }}>
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#A7D7D1]">About A1 Rugs</p>
          <h2 className="mt-4 max-w-xl text-3xl font-bold leading-tight sm:text-4xl lg:text-5xl">Traditional craft for modern homes.</h2>
          <p className="mt-6 max-w-xl text-base leading-8 text-white/75 sm:text-lg">Every rug has its own character. We bring carefully selected handmade Afghan carpets together with timeless design, natural materials, and authentic craftsmanship.</p>
          <p className="mt-4 max-w-xl text-base leading-7 text-white/65">Our collection is made for people who want a piece with warmth, texture, and a story — without making the shopping experience complicated.</p>
          <div className="mt-8 flex flex-wrap gap-3 text-xs font-semibold uppercase tracking-wider text-white/80">
            <span className="rounded-full border border-white/15 bg-white/5 px-4 py-2">Handmade</span>
            <span className="rounded-full border border-white/15 bg-white/5 px-4 py-2">Afghan craft</span>
            <span className="rounded-full border border-white/15 bg-white/5 px-4 py-2">Worldwide shipping</span>
          </div>
          <button type="button" onClick={() => navigate("/aboutus")} className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#F8F3E7] px-7 py-3.5 text-sm font-bold text-[#0F766E] transition hover:-translate-y-0.5 hover:bg-white hover:shadow-xl">Discover our story <FaArrowRight className="text-xs" /></button>
        </motion.div>
      </div>
    </section>
  );
}
